import React from 'react';
import { WhatsAppButton } from './WhatsAppButton';
export function Intro() {
  return <section id="sobre-nosotros" className="bg-ivory-50" data-id="element-47" data-mp="27gi7a68xodkl">
      <div className="mx-auto max-w-4xl px-5 py-20 lg:px-8 lg:py-28" data-id="element-48" data-mp="27fyo6m7jrj4z">
        <p className="text-[11px] font-semibold uppercase tracking-[0.28em] text-gold-600" data-id="element-49" data-mp="2leooeapnxyxk">
          Brujería Mayor
        </p>
        <h2 className="mt-5 font-display text-2xl font-semibold leading-snug text-emerald-900 sm:text-4xl" data-id="element-50" data-mp="2getxi75w19ci">
          Prácticas tradicionales de brujería y orientación espiritual
        </h2>

        <div className="mt-8 space-y-6 text-base leading-relaxed text-graphite-700" data-id="element-51" data-mp="1nu2dypbrhnij">
          <p data-id="element-52" data-mp="22iq6snu83j4s">
            Descubre nuestras prácticas tradicionales de brujería y orientación
            espiritual. Ofrecemos consultas y rituales personalizados para
            personas que desean explorar diferentes aspectos de su vida
            personal, sentimental y espiritual.
          </p>
          <p data-id="element-53" data-mp="151894o7urbs1">
            Trabajamos desde la brujería y la hechicería tradicional: amarres,
            pactos, rituales y trabajos de protección, abordados con la
            seriedad y la reserva que estos temas exigen.
          </p>
          <p data-id="element-54" data-mp="bg56kc2vvcqn">
            Nuestro objetivo es ofrecer un espacio de consulta privada,
            respetuosa y personalizada para quienes desean conocer más sobre
            estas prácticas y tradiciones.
          </p>
        </div>

        <WhatsAppButton className="mt-10 w-full sm:w-auto" data-id="element-55" data-mp="3exnaw9jg61mb" />
      </div>
    </section>;
}